<template>
  <span class="locale-changer">
    <v-menu top offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          small
          v-bind="attrs"
          v-on="on"
        >
          {{$i18n.locale}}
        </v-btn>
      </template>

      <v-list class="py-0" elevation="5">
        <v-list-item
          v-for="(item, index) in languages"
          :key="index"
          @click="$i18n.locale = item"
        >
          <v-list-item-title class="text-button text-center">{{ item }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </span>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { langs: ['is', 'en'] }
  },
	computed: {
    languages() {
      return this.$i18n.availableLocales
    },
		defaultLanguage() {
      return this.$store.getters.defaultLanguage
		}
	},
	mounted() {
    if(this.defaultLanguage !== null && this.defaultLanguage !== undefined) {
      try {
        this.$i18n.locale = this.defaultLanguage.toLowerCase()
      } catch (e) {
        this.$i18n.locale = 'is'
      }
    }
	},
	watch: {
    defaultLanguage(value) {
      if(value) {
        this.$i18n.locale = value.toLowerCase()
      }
    }
	}
}
</script>
